export default "__VITE_ASSET__AJa7WoxJ__"